import { Check, X } from 'lucide-react';
import { cn } from '@/utils';
import type { BetPlaceResponse } from '@/types/betPlace';

interface BetPlacementToastProps {
  response?: BetPlaceResponse;
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

export default function BetPlacementToast({
  response,
  message,
  type,
  onClose,
}: BetPlacementToastProps) {
  const bet = response?.bet;
  const isSuccess = type === 'success';
  const betOn = String(bet?.betOn ?? '').toLowerCase();

  return (
    <div
      className={cn(
        'w-full overflow-hidden rounded-t-xl text-white shadow-[0_-8px_24px_rgba(0,0,0,0.25)]',
        isSuccess ? 'bg-[#5abe00]' : 'bg-[#f00000]'
      )}
    >
      <div className="relative flex h-11 items-center justify-center px-12 text-[1rem] leading-tight font-bold">
        {isSuccess && (
          <span className="mr-2 inline-flex size-6 items-center justify-center rounded-full bg-white text-[#5abe00]">
            <Check size={19} strokeWidth={3} />
          </span>
        )}
        <span className="line-clamp-2">{message}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close bet message"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white"
        >
          <X size={30} strokeWidth={3} />
        </button>
      </div>

      <div
        className={cn(
          'mx-1 mb-1 flex min-h-[3.375rem] items-center justify-center gap-3 rounded-lg px-3 text-black',
          isSuccess ? 'bg-[#edf9df]' : 'bg-[#f9d8d8]'
        )}
      >
        {bet ? (
          <>
            <span
              className={cn(
                'rounded-full px-4 py-2 text-[1rem] font-bold leading-none',
                betOn === 'lay' ? 'bg-lay' : 'bg-back'
              )}
            >
              {betOn || 'bet'}
            </span>
            <span className="min-w-0 truncate text-[1rem]">{bet.selection}</span>
            <span className="h-7 w-px bg-[#b9d7e7]" />
            <span className="text-[1rem]">{bet.odds}</span>
          </>
        ) : (
          <span className="text-[0.938rem] font-semibold">{message}</span>
        )}
      </div>
    </div>
  );
}
